<template>
  <div id="app">
    <!-- 全局布局可放在这里，或在index.vue中实现 -->
    <router-view />
  </div>
</template>

<script setup lang="ts">
// 根组件无需复杂逻辑，仅作为路由容器
</script>

<style>
#app {
  height: 100vh;
  margin: 0;
  padding: 0;
}
/* 在App.vue或全局样式文件中添加 */
html, body {
  margin: 0;
  padding: 0px;
  height: 100%;
  overflow: hidden; /* 防止全局滚动 */
}

/* 如果需要整体页面可滚动 */
body {
  overflow-y: auto; /* 仅在内容超出视口时显示垂直滚动条 */
}
</style>
